// List of 10 states (including Maharashtra and 9 nearby states) and their major cities
// You can expand this list as needed

export const stateCityList = [
  {
    state: 'Maharashtra',
    cities: [
      'Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Aurangabad', 'Solapur', 'Thane', 'Kolhapur', 'Amravati', 'Nanded'
    ]
  },
  {
    state: 'Gujarat',
    cities: [
      'Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Junagadh', 'Gandhinagar', 'Anand', 'Navsari'
    ]
  },
  {
    state: 'Goa',
    cities: [
      'Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda', 'Bicholim', 'Curchorem', 'Sanquelim', 'Valpoi', 'Canacona'
    ]
  },
  {
    state: 'Madhya Pradesh',
    cities: [
      'Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar', 'Dewas', 'Satna', 'Ratlam', 'Rewa'
    ]
  },
  {
    state: 'Chhattisgarh',
    cities: [
      'Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg', 'Rajnandgaon', 'Jagdalpur', 'Ambikapur', 'Raigarh', 'Dhamtari'
    ]
  },
  {
    state: 'Karnataka',
    cities: [
      'Bengaluru', 'Hubli', 'Mysuru', 'Mangaluru', 'Belagavi', 'Davanagere', 'Ballari', 'Tumakuru', 'Shivamogga', 'Bidar'
    ]
  },
  {
    state: 'Telangana',
    cities: [
      'Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Ramagundam', 'Khammam', 'Mahbubnagar', 'Adilabad', 'Suryapet', 'Miryalaguda'
    ]
  },
  {
    state: 'Andhra Pradesh',
    cities: [
      'Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool', 'Rajahmundry', 'Tirupati', 'Kakinada', 'Kadapa', 'Anantapur'
    ]
  },
  {
    state: 'Rajasthan',
    cities: [
      'Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer', 'Bikaner', 'Alwar', 'Bhilwara', 'Sikar', 'Pali'
    ]
  },
  {
    state: 'Daman and Diu',
    cities: [
      'Daman', 'Diu'
    ]
  }
]; 